import '../markerclusterer.js';

import NidApp from './api';

/**
 * Store finder
 */
(function ($, nordsjo) {
  nordsjo.gMap = {};
  nordsjo.storeFinderMarkers = [];
  nordsjo.currentLocation = false;
  nordsjo.gmapsLoaded = false;
  nordsjo.markersClustered = false;
  nordsjo.markerCluster = {};

  nordsjo.clusterStyles = [{
    textColor: 'white',
    backgroundPosition: '10px 10px',
    url: nordsjo.mapIconLarge,
    height: 80,
    width: 80,
  }, ];

  nordsjo.mcOptions = {
    gridSize: 50,
    maxZoom: 14,
    averageCenter: true,
    styles: nordsjo.clusterStyles,
  };

  nordsjo.country = 'SE';

console.log(nordsjo.country);

  /**
   * Load an script
   * @param script
   * @returns {*}
   */
  function loadJS(script) {
    let deferred = jQuery.Deferred();
    jQuery.getScript(script).done(function (result) {
      deferred.resolve(result);
    });
    return deferred.promise();
  }

  /**
   * Determine the radius of on object.
   *
   * @return {int}
   */
  function rad(x) {
    return (x * Math.PI) / 180;
  }

  /**
   * If browser supports/allows geolocation return position
   *
   * @return Promise
   */
  function getDeviceLocation() {
    if (navigator.geolocation && 'https:' == document.location.protocol) {
      return new Promise(function (resolve, reject) {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          timeout: 60000,
        });
      });
    } else {
      return new Promise();
    }
  }

  /**
   * Get a store (and related metadata) via ID
   *
   * @param storeID Post_ID of the store to fetch.
   *
   * @return {object} Results of the AJAX call.
   */
  function storeFinderGetStore(storeID) {
    let deferred = jQuery.Deferred();

    jQuery
      .ajax({
        type: 'POST',
        url: nordsjo.ajaxurl,
        data: {
          action: 'nid_ajax_get_store_finder_store',
          id: storeID,
          nid_fast_ajax: 1,
        },
      })
      .done(function (result) {
        deferred.resolve(result);
      });

    return deferred.promise();
  }

  /**
   * Center the map with all the indicators.
   *
   * @param markers array
   */
  function centerStoreFinder(markers) {
    let bounds = new google.maps.LatLngBounds(),
      l = markers.length,
      i;

    for (i = 0; i < l; i++) {
      let marker = markers[i],
        latlng = new google.maps.LatLng(
          marker.position.lat(),
          marker.position.lng()
        );

      bounds.extend(latlng);
    }
    nordsjo.gMap.fitBounds(bounds);
  }

  /**
   * Turn store data into a map marker
   *
   * @param store
   * @returns {*|jvm.Marker}
   */
  function createStoreFinderMarker(store) {
    let marker = new google.maps.Marker({
      position: new google.maps.LatLng(store.position.lat, store.position.lng),
      map: nordsjo.gMap,
      icon: nordsjo.mapIcon,
      title: store.title,
    });

    marker.set('storeId', store.postID);
    marker.set('town', store.town);
    marker.set('address', store.position.address);
    marker.set('name', store.title);

    let infowindow = new google.maps.InfoWindow({
      content: '<strong>' + marker.name + '</strong><br />' + marker.town,
    });

    marker.addListener('click', function () {
      showStoreInfo(marker);
      nordsjo.gMap.setZoom(14);
      nordsjo.gMap.setCenter(marker.getPosition());
    });
    marker.addListener('mouseover', function () {
      infowindow.open(nordsjo.gMap, marker);
    });
    marker.addListener('mouseout', function () {
      infowindow.close();
    });

    return marker;
  }

  /**
   * Calculate the distance between 2 sets of coordinates.
   *
   * @param {object} p1 Object with lat, lng properties.
   * @param {object} p2 Object with lat, lng properties/
   *
   * @return {int} Distance in meters between the 2 points.
   */
  function storeFinderGetDistance(p1, p2) {
    let R = 6378137; // Earth’s mean radius in meter
    let dLat = rad(p2.lat() - p1.lat());
    let dLong = rad(p2.lng() - p1.lng());

    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(p1.lat())) *
      Math.cos(rad(p2.lat())) *
      Math.sin(dLong / 2) *
      Math.sin(dLong / 2);

    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c;

    return Math.ceil(d);
  }

  /**
   *
   * @param position
   * @returns {Array}
   */
  function getStoresWithinDistanceOfPosition(position) {

    let stores = [];
    let distance = 0;

    _.each(nordsjo.storeFinderMarkers, function (marker) {
      distance = storeFinderGetDistance(position, marker.position);

      // find any store within 10 km of position
      if (distance < 50000) {
        marker.distance = distance;
        stores.splice(distance, 0, marker);
      }
    });
    return stores;
  }

  /**
   * Reset the map view and store list
   */
  function resetStoresList() {
    let context = $('#storeFinder').data('context');

    if (context == 'shopping-cart' || context == 'change-store') {
      $('#stores .list li[data-can-recieve-orders=1]').show();
    } else if (context == 'service-booking') {
      $('#stores .list li[data-can-recieve-bookings=1]').show();
    } else if(context == 'service-help-booking') {
        $('#stores .list li[data-can-recieve-help-bookings=1]').show();
    } else {
      $('#stores .list li').show();
    }
    centerStoreFinder(nordsjo.storeFinderMarkers);
  }

  /**
   * Toggle visibility of stores in store list
   *
   * @param markers
   */
  function updateStoresList(markers) {
    let $storeList = $('#stores .list');

    $('li', $storeList).hide();

    _.each(markers, function (marker) {
      $('li[data-store-id=' + marker.storeId + ']', $storeList).show();
    });
  }

  /**
   *
   * @param storeID
   */
  function centerOnStore(storeID) {
    _.each(nordsjo.storeFinderMarkers, function (marker) {
      if (marker.storeId == storeID) {
        nordsjo.gMap.panTo(marker.position);
        showStoreInfo(marker);

        try {
          setTimeout(function () {
            nordsjo.gMap.setZoom(14);
          }, 1000);
        } catch (error) {
          console.log(error);
        }
      }
    });
  }

  nordsjo.centerOnStore = function (storeID) {
    centerOnStore(storeID);
  };

  /**
   *
   */
  function blankStoreInfo() {
    let $storeInfo = $('#store-info');
    let $header = $('.header', $storeInfo);
    let $contact = $('.contact', $storeInfo);
    let $more = $('.more', $storeInfo);

    $header.empty();
    $contact.empty();
    $more.empty();
  }

  /**
   *
   * @param store
   */
  function showStoreInfo(store) {
    let $storeInfo = $('#store-info');
    let $header = $('.header', $storeInfo);
    let $contact = $('.contact', $storeInfo);
    let $more = $('.more', $storeInfo);
    let context = $('#storeFinder').data('context');

    $header.empty();
    $contact.empty();
    $more.empty();

    $header.html(
      '<h2 class="store-header">' +
      store.name +
      '</h2><span class="address">' +
      store.address +
      '</span>'
    );

    storeFinderGetStore(store.storeId).done(function (response) {
      if (true === response.success) {
        $contact.html(response.data);
        $storeInfo.attr('data-store-id', store.storeId);
        let $button = $('button.action', $contact);

        // Prevert the go to store button if shoppinglist
        // Set the selected store as delivery point
        if ('shopping-cart' === context) {
          $button.on('click', function (e) {
            e.preventDefault();
            let $this = $(this);
            let $form = $('#select-checkout-store');

            // Add selected store id
            $form.append(
              `<input type="hidden" name="store_id" value="${store.storeId}" /> `
            );
            $this.attr('disabled', true);

            $form.submit();
          });
        } else if ('contact-store' === context) {
          $button.on('click', function (e) {
            e.preventDefault();
            let $this = $(this);

            $this.attr('disabled', true);

            $.ajax({
                type: 'POST',
                url: nordsjo.ajaxurl,
                data: {
                  action: 'nid_shoppinglist_set_selected_store',
                  store_id: store.storeId,
                },
              })
              .done(function (response) {
                $this.remove();

                let $doneButton = $('<button />', {
                  class: 'button',
                  id: 'close-store-finder-modal',
                });
                $doneButton.html(nordsjo.tDone);
                $doneButton.insertAfter('.opening-hours-list');

                $doneButton.on('click', function (e) {
                  e.preventDefault();
                  nordsjo.hideStorePicker();
                });
              })
              .fail(function (response) {
                console.log(response);
              });
          });
        } else if ('change-store' === context) {
          $button.on('click', function (e) {
            e.preventDefault();
            let $this = $(this);

            $this.attr('disabled', true);

            $.ajax({
                type: 'POST',
                url: nordsjo.ajaxurl,
                data: {
                  action: 'nid_shoppinglist_set_selected_store',
                  store_id: store.storeId,
                },
              })
              .done(function (response) {
                location.reload();
              })
              .fail(function (response) {
                console.log(response);
              });
          });
        } else if ('service-booking' === context) {
          $button.on('click', function (e) {
            e.preventDefault();
            let $this = $(this);

            $this.attr('disabled', true);

            $.ajax({
                type: 'POST',
                url: nordsjo.ajaxurl,
                data: {
                  action: 'nid_service_booking_set_selected_store',
                  store_id: store.storeId,
                },
              })
              .done(function (response) {
                let markup = response.data._markup;
                if (markup) {
                  $('.selected-store').html(markup);
                  nordsjo.hideStorePicker();

                  $('.service-booking-form').removeClass('is-hidden');
                } else {
                  location.reload();
                }
              })
              .fail(function (response) {
                console.log(response);
              });
          });
        } else {
          $button.on('click', function (e) {
            e.preventDefault();

            window.open($button.data('href'), '_blank').focus();
          });
        }
      }
    });
  }

  /**
   *
   * @param markers
   * @param center
   */
  function renderGmap(markers, center) {
    if (true === center) {
      centerStoreFinder(markers);
    }

    nordsjo.markerCluster = new MarkerClusterer(
      nordsjo.gMap,
      markers,
      nordsjo.mcOptions
    );
  }

  /**
   * Center the map at a given position, default zoom
   *
   * @param position
   */
  function centerMap(position) {
    if ('undefined' !== typeof position) {
      nordsjo.gMap.setCenter({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });
      nordsjo.gMap.setZoom(8);
    }
  }

  /**
   * Bind a search field to a geocode lookup
   *
   * @param geocoder
   * @param map
   */
  function storeFinderSearchByTown(geocoder, map) {
    let town = document.getElementById('store-search').value;
    let $feedback = $('#feedback');
    let foundStores = [];
    let pattern = '';

    blankStoreInfo();
    $feedback.html('');

    _.each(nordsjo.storeFinderMarkers, function (store) {
      pattern = new RegExp(town, 'i');

      if (store.town.search(pattern) != -1) {
        foundStores.push(store);
      }
    });

    if (foundStores.length === 0) {
      geocoder.geocode({
          address: town,
          componentRestrictions: {
            country: nordsjo.country
          }
        },
        function (results, status) {
          if (status == 'OK') {
            map.setCenter(results[0].geometry.location);
            let marker = new google.maps.Marker({
              map: map,
              position: results[0].geometry.location,
            });

            foundStores = getStoresWithinDistanceOfPosition(marker.position);
            if (foundStores.length === 0) {
              $feedback.html(nordsjo.noNearbyStores);
            } else if (foundStores.length === 1) {
              map.setZoom(14);
              map.panTo(foundStores[0].position);
              showStoreInfo(foundStores[0]);
              updateStoresList(foundStores);
            } else {
              centerStoreFinder(foundStores);
              updateStoresList(foundStores);
            }
          } else {
            if (status == 'ZERO_RESULTS') {
              status = nordsjo.noHitsWithinArea;
            }
            $feedback.html(nordsjo.lookupFailed + ' ' + status);
          }
        }
      );
    } else {
      if (foundStores.length === 1) {
        map.setZoom(14);
        map.panTo(foundStores[0].position);
        showStoreInfo(foundStores[0]);
        updateStoresList(foundStores);
      } else {
        centerStoreFinder(foundStores);
        updateStoresList(foundStores);
      }
    }
  }

  /**
   * Bind all events to map, stores list and search
   */
  function bindMapEvents() {
    // Bind store list clicks
    let $storeList = $('#stores .list');
    let $nearMe = $('#near-me');
    $storeList.click(function (e) {
      e.preventDefault();
      let $this = $(e.target);
      let storeID = $this.data('store-id');

      centerOnStore(storeID);
    });

    // Bind search function
    let geocoder = new google.maps.Geocoder();
    document.getElementById('search').addEventListener('click', function (e) {
      e.preventDefault();

      storeFinderSearchByTown(geocoder, nordsjo.gMap);
    });

    // Bind near me function
    document.getElementById('near-me').addEventListener('click', function (e) {
      e.preventDefault();
      $('#feedback').hide();

      if (navigator.geolocation && 'https:' == document.location.protocol) {
        if (false !== nordsjo.currentLocation) {
          centerMap(nordsjo.currentLocation);
        } else {
          $nearMe.addClass('working').attr('disabled', true);
          getDeviceLocation()
            .then(function (position) {
              if (false !== position) {
                nordsjo.currentLocation = position;
                centerMap(position);
              }
              $nearMe.removeClass('working').attr('disabled', false);
            })
            .catch(function (error) {
              console.log(error);
              let msg = nordsjo.tMapError;
              switch (error.code) {
                case error.PERMISSION_DENIED:
                  msg = nordsjo.tMapErrorGeolocationDenied;
                  break;
                case error.POSITION_UNAVAILABLE:
                  msg = nordsjo.tMapErrorNoGeolocation;
                  break;
                case error.TIMEOUT:
                  msg = nordsjo.tMapErrorTimeout;
                  break;
                case error.UNKNOWN_ERROR:
                  msg = nordsjo.tMapError;
                  break;
              }

              $nearMe.removeClass('working').attr('disabled', false);
              $('#feedback')
                .html(msg)
                .show();
            });
        }
      }
    });

    document.getElementById('show-all').addEventListener('click', function (e) {
      e.preventDefault();

      resetStoresList();
    });

    // Update store list to reflect visible markers
    google.maps.event.addListener(nordsjo.gMap, 'bounds_changed', function () {
      let visibleMarkers = [];
      for (let i = 0; i < nordsjo.storeFinderMarkers.length; i++) {
        if (
          nordsjo.gMap
          .getBounds()
          .contains(nordsjo.storeFinderMarkers[i].getPosition())
        ) {
          visibleMarkers.push(nordsjo.storeFinderMarkers[i]);
        }
      }
      updateStoresList(visibleMarkers);
      $('#feedback')
        .html('')
        .hide();
    });
  }

  /**
   * Set up and init the store picker
   */
  nordsjo.initGmap = function () {
    let $map = $('#gmap');
    let context = $('#storeFinder').data('context');

    // Get the country ISO code
    nordsjo.country = $('html')
      .attr('lang')
      .substring(3);

    if ($map.length > 0) {
      let script = document.createElement('script');
      let center = true;

      $map.css('height', '500px');

      if (nordsjo.gmapsLoaded === false) {
        script.type = 'text/javascript';
        script.src =
          'https://maps.googleapis.com/maps/api/js?v=3.exp&key=' +
          nordsjo.googleMapsAPIKey +
          '&callback=initMap';
        document.body.appendChild(script);
        nordsjo.gmapsLoaded = true;
      } else {
        initMap();
      }

      window.initMap = function () {
        renderMap();

        if (navigator.geolocation && 'https:' == document.location.protocol) {
          $('#storeFinder').addClass('has-location-support');
        }
      };

      window.renderMap = function () {
        let initVars = {
          zoom: 4,
          center: {
            lat: 62.7876923,
            lng: 15.5776094
          },
          mapTypeId: google.maps.MapTypeId.ROADMAP,
        };
        nordsjo.gMap = new google.maps.Map(
          document.getElementById('gmap'),
          initVars
        );

        if (nordsjo.storeFinderMarkers.length === 0) {
          // Only add the markers that are appropriate for the current context
          _.each(nordsjo.stores, function (store) {
            if (
              context === 'page' ||
              (context === 'shopping-cart' && store.canRecieveOrders === 1) ||
              (context === 'change-store' && store.canRecieveOrders === 1) ||
              // (context === 'contact-store' && store.canRecieveOrders === 1) ||
              (context === 'contact-store') ||
              (context === 'service-booking' && store.canRecieveBookings === 1)
            ) {
              nordsjo.storeFinderMarkers.push(createStoreFinderMarker(store));
            }
          });
        }

        $.when(loadJS(nordsjo.markerclustererUrl)).done(function (result) {
          renderGmap(nordsjo.storeFinderMarkers, center);

          bindMapEvents();

          let currentStoreID = $('#storeFinder').data('store-id');
          nordsjo.centerOnStore(currentStoreID);
        });
      };
    }
  };

  /**
   *
   */
  nordsjo.initLocalStoreMap = function () {
    let $storeMap = $('.store-map');

    /**
     * Render the Google map for an about page
     */
    window.renderSingleStoreMap = function ($storeMap) {
      let latlng = new google.maps.LatLng(
        $storeMap.attr('data-lat'),
        $storeMap.attr('data-lng')
      );

      let mapOptions = {
        center: latlng,
        zoom: 14,
      };

      let map = new google.maps.Map(
        document.getElementById('store-map'),
        mapOptions
      );

      if ($(window).width() <= 768) {
        map.setOptions({
          draggable: false,
          scrollwheel: false,
        });
      }

      let marker = new google.maps.Marker({
        position: mapOptions.center,
        map: map,
        icon: nordsjo.mapIcon,
      });
    };

    if ($storeMap.length === 0) {
      return;
    }

    renderSingleStoreMap($storeMap);
  };

  /**
   * Init the store finder JS
   */
  $(document).ready(function () {
    nordsjo.initGmap();
    nordsjo.initLocalStoreMap();
  });

  /**
   * Get a store's info via AJAX
   *
   * @param storeID
   * @return {*}
   */
  nordsjo.getStore = function (storeID) {
    let deferred = jQuery.Deferred();

    $.ajax({
        type: 'POST',
        url: nordsjo.ajaxurl,
        data: {
          action: 'nid_get_store_data',
          store_id: storeID,
        },
      })
      .done(function (response) {
        deferred.resolve(response.data.store);
      })
      .fail(function (response) {
        console.log(response);
      });

    return deferred.promise();
  };

  /**
   * Get the store finder markup via AJAX
   *
   * @return {*}
   */
  nordsjo.renderStoreMap = function (context) {
    let deferred = jQuery.Deferred();

    $.ajax({
        type: 'POST',
        url: nordsjo.ajaxurl,
        data: {
          action: 'nid_get_storefinder',
          context: context,
        },
      })
      .done(function (response) {
        deferred.resolve(response.markup);
      })
      .fail(function (response) {
        console.log(response);
      });

    return deferred.promise();
  };

  /**
   * Add a store picker modal to page and show it
   *
   * @param markup
   */
  nordsjo.addStoreMapModal = function (markup) {
    let $container = $('<div />', {
      class: 'store-finder-modal modal fade',
      id: 'store-finder-modal',
    });
    $('<div />', {
        class: 'inner container'
      })
      .html(markup)
      .appendTo($container);

    $container.appendTo('.modal-d-container');
    $container.show();
    $container.find('.container').on('click', function (e) {
      if (e.target !== this) {
        return;
      }
      nordsjo.hideStorePicker();
    });
    $container.find('.close-modal').on('click', function (e) {
      nordsjo.hideStorePicker();
    });
  };

  /**
   * Fetch markup for store picker modal, init the JS
   */
  nordsjo.showStorePicker = function (context = 'shopping-cart') {
    $.when(nordsjo.renderStoreMap(context)).then(function (markup) {
      nordsjo.addStoreMapModal(markup);
      nordsjo.initGmap();
    });
  };

  /**
   * Hide the store finder modal
   */
  nordsjo.hideStorePicker = function () {
    NidApp.removeLoadingIcon();
    $('.store-finder-modal').remove();
  };
})(jQuery, nordsjo);
